var React = require('react');

function Upload (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M18.7 41.8 55 10M55 72V10l36.3 31.8","fill":"none","stroke":"#ee693f","strokeWidth":"5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","className":"stroke-ee693f","key":0}),React.createElement("path",{"d":"M10 80v20h90V80","fill":"none","stroke":"#ffffff","strokeWidth":"5","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","className":"stroke-545454","key":1})]);
}

Upload.defaultProps = {"viewBox":"0 0 110 110","xmlSpace":"preserve","enableBackground":"new 0 0 110 110"};

module.exports = Upload;

Upload.default = Upload;
